<template>
    <v-container
    >
        <v-dialog
                v-model="dialog"
                fullscreen
                transition="dialog-bottom-transition">

            <template v-slot:activator="{ on }">
                <v-btn
                        v-on="on"
                        icon
                        @click="init">
                    <v-icon>mdi-email-open</v-icon>
                </v-btn>
            </template>
            <v-card
                    tile
                    :loading="loading">
                <v-toolbar
                        dense
                        fixed
                        color="secondary"
                        style="width: 100%; position: fixed; z-index: 100">
                    <v-btn
                            icon
                            @click="close">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{ $t('RawMessageViewer.originalEmail') }}</v-toolbar-title>
                    <v-spacer/>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                    v-on="on"
                                    icon
                                    @click="triggerDownload">
                                <v-icon>mdi-download</v-icon>
                            </v-btn>
                        </template>
                        <span>Nachricht herunterladen</span>
                    </v-tooltip>
                </v-toolbar>
                <v-card-text>
                    <v-flex sx12 style="padding-top: 64px;">
                        <span :hidden="!error">{{ $t('RawMessageViewer.hidden') }}</span>
                        <pre>{{ this.raw }}</pre>
                    </v-flex>
                </v-card-text>
            </v-card>
            <a
                    hidden
                    ref="download"
                    :download="this.$t('RawMessageViewer.message') + msgUuid + '.htm'"
                    :href="data"/>
        </v-dialog>
    </v-container>
</template>

<script>

    import axios from 'axios'

    export default {
        props: {
            messageUuid: {
                type: String
            },
        },
        data() {
            return {
                dialog: false,
                error: false,
                loading: true,
                raw: null,
                msgUuid: {},
                data: ''
            }
        },
        methods: {
            init(uuid) {
                if (uuid) {
                    this.msgUuid = uuid;
                } else {
                    this.msgUuid = this.messageUuid;
                }
                this.dialog = true;
                this.loading = true;
                axios.get('/legacy-m2m/api/raw/' + this.msgUuid + '/')
                    .then(response => {
                        this.raw = response.data;
                        this.loading = false;
                        this.data = "data:text/html;base64," + btoa(this.raw)
                    })
                    .catch(() => {
                        this.error = true;
                        this.loading = false
                    })
            },
            close() {
                this.dialog = false;
            },
            triggerDownload() {
                this.$refs.download.click();
            }
        }
    }
</script>